import { useState } from 'react';
import { DictionaryDataFetchWrapper } from '../wrappers/DictionaryDataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { useDevice } from '../../model/DeviceContext';

export const useWasteProcessData = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);
    const { isTrial } = useDevice(); // Get isTrial from context when hook is used
    const sheetName = "SL02 Procesy przetwarzania";


    const fetchWasteProcessData = () => {
        const dataFetch = DictionaryDataFetchWrapper.wrapDictionaryWasteProcessDataFetch(sheetName, isTrial);
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    };

    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
    };

    const handleProgressComplete = (wasSuccess: boolean) => {
        resetProgress();
        if (wasSuccess && onComplete) {
            onComplete();
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchWasteProcessData,
        resetProgress,
        handleProgressComplete
    };
};